import { render, staticRenderFns } from "./ListPages.vue?vue&type=template&id=12db4566"
import script from "./ListPages.vue?vue&type=script&lang=js"
export * from "./ListPages.vue?vue&type=script&lang=js"
import style0 from "./ListPages.vue?vue&type=style&index=0&id=12db4566&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports